import styled from 'styled-components'

const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`
const background = props => props.theme.colors.lightGray20 || 'gray'

export default styled.div`
    background: ${background};
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
    z-index: 0;
    scroll-behavior: smooth;
    margin-bottom: 25px;

    ${mediaScreenMobile} {
        width: 100%;
        position: relative;
        margin-bottom: 0;
    }
`
